import axios from './api'
const myServer = {	
	User(params) {
		return axios.post(`app/user/getBasic`, params).then((res) => {
            return res.data
        })
	},
	FullDetail(params) {
		return axios.post(`app/wallet/record/page`, params).then((res) => {
            return res.data
        })
	},
	SearchWallet(params) {
		return axios.post(`app/wallet/get`, params).then((res) => {
            return res.data
        })
	},
	PostFull(params) {
		return axios.post(`app/wallet/recharge/submit`, params).then((res) => {
            return res.data
        })
	},
	SearchKefu(params) {
		return axios.post(`app/recharge/customer/listAll`, params).then((res) => {
            return res.data
        })
	}
	



}
export default myServer


// WEBPACK FOOTER //
// ./src/api/my.js